import request from '@/utils/request'

// 开启全病程确认
export function getPatientFile(data) {
  return request({
    url: '/health-patient/patient/archives/info',
    method: 'get',
    params: data
  })
}
// 患者协同备注
export function patientWithProfile(data) {
  return request({
    url: '/health-patient/patient/archives/patient-with-profile/info',
    method: 'get',
    params: data
  })
}

export function patientWithDoctor(data) {
  return request({
    url: '/health-patient/patient/archives/patient-with-doctor/info',
    method: 'get',
    params: data
  })
}
// 患者id 查询手机号
export function getPhoneByPatientId(data) {
  return request({
    url: '/health-patient/patientPhoneRel/list-by-patientId',
    method: 'get',
    params: data
  })
}
export function getPhonesByPhone(data) {
  return request({
    url: '/health-patient/patientPhoneRel/list-by-phone',
    method: 'get',
    params: data
  })
}
// 患者新增关联手机号
export function savePhone(data) {
  return request({
    url: '/health-patient/patientPhoneRel/save',
    method: 'post',
    data: data
  })
}

export function deletePhoneById(data) {
  return request({
    url: '/health-patient/patientPhoneRel/delete-by-id',
    method: 'get',
    params: data
  })
}
export function getID(data) {
  return request({
    url: '/health-patient/patient/get-id-card',
    method: 'get',
    params: data
  })
}
export function getLabelConfig(data) {
  return request({
    url: '/health-patient/patientLabelConfig/list',
    method: 'get',
    params: data
  })
}
// 保存标签
export function saveBatch(data) {
  return request({
    url: '/health-patient/patientLabelResultV2/batch-save',
    method: 'post',
    data: data
  })
}
// 就诊记录
export function diseaseCourseList(data) {
  return request({
    url: '/health-doctor-assistant/patient/archives/diseaseCourseList',
    method: 'get',
    params: data
  })
}
// 预注册患者
export function savePrePatient(data) {
  return request({
    url: '/health-patient/prePatient/save',
    method: 'post',
    data: data
  })
}
// 更新患者
export function updatePrePatient(data) {
  return request({
    url: '/health-patient/prePatient/update',
    method: 'post',
    data: data
  })
}

// 获取随访列表
export function getFollowPlanForPatientArchives(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getFollowPlanForPatientArchives',
    method: 'post',
    data: data
  })
}
// 获取复诊信息
export function queryCureUnLimitRecently(data) {
  return request({
    url: '/health-cure/cure/reserve/queryCureUnLimitRecently',
    method: 'get',
    params: data
  })
}
export function getPatientName(data) {
  return request({
    url: '/health-patient/patient/get-by-name',
    method: 'get',
    params: data
  })
}
// 就诊记录-门诊就诊详情
export function getOfflineCase(data) {
  return request({
    url: '/health-emr/offline/case/detail',
    method: 'get',
    params: data
  })
}

// 就诊记录-线上问诊多个处方
export function getPrescriptionListByConsult(data) {
  return request({
    url: '/health-recommend/recommend/prescription/recom/getPrescriptionListByConsult',
    method: 'get',
    params: data
  })
}
// 物流详情
export function getLogistics(data) {
  return request({
    url: '/health-recommend/recom/shippingList',
    method: 'get',
    params: data
  })
}
// 发起私聊
export function patientChatForArchives(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/patientChatForArchives',
    method: 'get',
    params: data
  })
}
// 新增患者预存档案
export function prePatientSave(data) {
  return request({
    url: '/health-patient/prePatient/save',
    method: 'post',
    data
  })
}
// 患者关联匹配
export function patientPhoneRel(data) {
  return request({
    url: '/health-patient/patientPhoneRel/match',
    method: 'post',
    data
  })
}

// 创建导诊
export function medicalGuide(data) {
  return request({
    url: '/health-cure/cure/consult/patient/medical-guide',
    method: 'post',
    data
  })
}
// 通过手机号匹配患者/预患者信息
export function getInfoByPhone(data) {
  return request({
    url: '/health-patient/patient/match-phone',
    method: 'get',
    params: data
  })
}

/**
 * 患者近期待办汇总
 * @param data
 *    ucPatientId：患者id
 *    type: 代办类型，如下，不传默认全部
 *        PRESCRIPTION(1, "处方", "prescription"),
 *        PRE_MEDICAL_RECORD(2, "预病历", "preMedicalRecord"),
 *        FOLLOWUP_VISIT(3, "复诊", "followupVisit"),
 *        FOLLOWUP_MANAGE(4, "随访管理", "followupManage"),
 *        PLATFORM(5, "平台相关", "platform");
 * @returns
 */
export function getSummaryTodo(data) {
  return request({
    url: '/health-patient/backlog/recent/summary',
    method: 'get',
    params: data
  })
}

/**
 * 患者画像详情
 * @param data
 *   ucDoctorId: 医生用户中心ID
 *   ucPatientId: 患者用户中心ID
 */
export function getPatientPortraitDetail(data) {
  return request({
    url: '/health-user/patient-portrait/detail',
    method: 'get',
    params: data
  })
}

export function getPatientPortraitDict() {
  return request({
    url: '/health-user/patient-portrait/dict',
    method: 'get'
  })
}

export function modifyPatientPortrait(data) {
  return request({
    url: '/health-user/patient-portrait/modify',
    method: 'post',
    data
  })
}

// 手动刷新患者画像
export function refreshPatientPortrait(data) {
  return request({
    url: '/health-user/patient-portrait/refresh',
    method: 'post',
    data
  })
}

// 记录患者画像已读
export function readPatientPortrait(data) {
  return request({
    url: '/health-user/patient-portrait/read',
    method: 'post',
    data
  })
}

// 查询患者画像刷新状态
export function getPatientPortraitRefreshStatus(data) {
  return request({
    url: '/health-user/patient-portrait/refresh/status',
    method: 'get',
    params: data
  })
}

// 查询医患进行中的患者画像刷新任务
export function getPatientPortraitRefreshTask(data) {
  return request({
    url: '/health-user/patient-portrait/refresh/processing',
    method: 'get',
    params: data
  })
}

/**
 * 患者平台待办-关闭免打扰
 * @param data
 *    ucPatientId：患者id
 * @returns
 */
export function postCloseEnd(data) {
  return request({
    url: '/health-patient/backlog/recent/platform/closeDnd',
    method: 'post',
    params: data
  })
}

/**
 * 患者平台待办-置顶公众号
 * @param data
 *    ucPatientId：患者id
 * @returns
 */
export function postPinOfficial(data) {
  return request({
    url: '/health-patient/backlog/recent/platform/pinOfficial',
    method: 'post',
    params: data
  })
}

/**
 * 根据医生和患者ID获取已填写的随访卡片
 * @param data
 *    ucDoctorId: 医生用户中心ID
 *    ucPatientId: 患者用户中心ID
 */
export function getFilledFollowUpCardsByDoctorAndPatient(data) {
  return request({
    url: '/health-followup/followup/followUpPlanCard/getFilledFollowUpCardsByDoctorAndPatient',
    method: 'get',
    params: data
  })
}

/**
 * 获取患者疗效跟踪反馈聚合信息
 * @param data
 *    ucDoctorId: 医生用户中心ID
 *    ucPatientId: 患者用户中心ID
 */
export function getFollowUpTreatmentOverview(data) {
  return request({
    url: '/health-followup/followup/followUpPlanCard/getFollowUpTreatmentOverview',
    method: 'get',
    params: data
  })
}

// 查询异常订单信息
export function getLogisticsAbnormal(data) {
  return request({
    url: '/health-doctor-assistant/healthManager/order/query',
    method: 'post',
    data: data
  })
}
export function urgeDelivery(data) {
  return request({
    url: '/health-doctor-assistant/healthManager/urgeDelivery',
    method: 'post',
    data: data
  })
}

// 查询健管操作记录列表
export function getOperationRecords(data) {
  return request({
    url: '/health-doctor-assistant/healthManager/operation/records',
    method: 'get',
    params: data
  })
}
// 查询医患下次回访信息
export function getNextFollowupInfo(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/next-followup-info',
    method: 'get',
    params: data
  })
}
